// let localHost =     'http://localhost:4000/dev';
// let liveHost =      'http://localhost:4000/dev';

let localHost =     'https://api.opexlogistics.co.uk/v1';
let liveHost =     'https://api.opexlogistics.co.uk/v1';


export const SiteConfig = {
    feedWidth:       690,
    bannerWidth:    1095,
    bannerHeight:   405,
    apiKey:         "133asdkjASFFAS3SD3553ASDFFDS982kjdlkasjdak",
    logging:        true,
    //endpoint:   'https://api.crgo.co.uk/v1',
    
    endpoint:   window.location.hostname.includes('localhost') ? localHost : liveHost,
    cookieName: 'clients.opex',
    logos:      {
        lightLogo:  '/images/yadoologopink.png',
        darkLogo:   '/images/yadoologopink.png',
        alt:        'Yadoo'
    },
    logOut:     {
        units:      10,
        unitType:   'hours'
    }
}

export default SiteConfig;